import { styled } from "@mui/material";
import {
  ContentEditable as LexicalContentEditable
} from "@lexical/react/LexicalContentEditable";
import { editorName } from "../classes.js";
const ContentEditable = styled(LexicalContentEditable, {
  name: editorName,
  slot: "ContentEditable",
  overridesResolver: (_, styles) => styles.contentEditable
})(({ theme, ownerState }) => ({
  border: "none",
  display: "block",
  outline: "none",
  padding: theme.spacing(2),
  flexGrow: 1,
  ...ownerState?.disabled && {
    cursor: "default"
  }
}));
export {
  ContentEditable
};
//# sourceMappingURL=ContentEditable.js.map
